import './App.css';
import { useState } from 'react';

function App() {

  const [results, setResults] = useState({
    loanAm: 50000,
    estPrMon: 439
  });
  const [state, setState] = useState({
    PPrice: 100000,
    DPay: 50000,
    RepayT: 10,
    IntRate: 1
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value
    });
  };

  const genQuote = () => {
    const P=Math.max(state.PPrice-state.DPay,0);
    const n=state.RepayT*12;
    const r=state.IntRate/1200;

    const M=Math.ceil(P*(r*((1+r)**n))/(((1+r)**n)-1));
    setResults({loanAm: P, estPrMon:M})
  }

  return (
    <div
    className="m-4 p-6 bg-teal-200 rounded-2xl
    border-4 border-teal-400 mt-0 shadow-lg">
      <h1 className="text-[1.4rem] font-semibold">
        Mortgage Calcutor
      </h1>
      <div
      className="container mx-auto grid
      sm:grid-cols-1 md:grid-cols-2
      lg:grid-cols-3 xl:grid-cols-3
      pt-6 gap-8 sm:min-w-[15rem]">
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Purchase price: <b
          className="font-semibold"
          >${state.PPrice}</b>
          </h6>   
          <input
          className="w-48"
          name="PPrice"
          value={state.PPrice}
          type="range"
          step="1000"
          min="0"
          max="1000000"
          onChange={ handleChange }
          />
        </div>
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Down payment: <b
          className="font-semibold"
          >${Math.min(state.DPay,state.PPrice)}</b>
          </h6>   
          <input
          className="w-48"
          name="DPay"
          value={Math.min(state.DPay, state.PPrice)}
          type="range"
          step="1000"
          min="0"
          max="999000"
          onChange={ handleChange }
          />
        </div>
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Repayment time: <b
          className="font-semibold"
          >{state.RepayT} yr{state.RepayT>1 ? "s" : ""}</b>
          </h6>   
          <input
          className="w-48"
          name="RepayT"
          type="range"
          defaultValue="10"
          step="1"
          min="1"
          max="30"
          onChange={ handleChange }
          />
        </div>
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Interest rate: <b
          className="font-semibold"
          >{state.IntRate}%</b>
          </h6>   
          <input
          className="w-48"
          name="IntRate"
          type="range"
          defaultValue="1"
          step="0.5"
          min="0.5"
          max="10"
          onChange={ handleChange }
          />
        </div>
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Loan amount:</h6>   
          <span
          className="text-xl font-semibold"
          >${results.loanAm}</span>
        </div>
        <div>
          <h6
          className= "text-sm font-medium mb-2"
          >Estimated pr. month:</h6>   
          <span
          className="text-xl font-semibold"
          >${results.estPrMon}</span>
        </div>
      </div>
      <button
      className="text-white right-2.5 bottom-2.5
      bg-sky-700 hover:bg-sky-800 focus:ring-4
      focus:outline-none focus:ring-blue-300
      font-medium rounded-md text-sm px-[1.15rem]
      py-2.5 mt-10"
      onClick={genQuote}
      >Get a Mortgage quote
      </button>
    </div>
  );
}

export default App;
